export default class CampaignContactDetailController {
    /* @ngInject */
    constructor(
        $scope,
        $state,
        $stateParams,
        $ionicLoading,
        $q,
        ApiContacts,
        ApiCampaigns,
        ApiTasks,
        DATE_FORMAT,
        ApiPicklist,
        $ionicPopup,
        $filter,
        MessageBox
    ) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$ionicLoading = $ionicLoading;
        this.$q = $q;
        this.ApiContacts = ApiContacts;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiTasks = ApiTasks;
        this.ApiPicklist = ApiPicklist;
        this.DATE_FORMAT = DATE_FORMAT;
        this.contact = {};
        this.contactId = $stateParams.contactId;
        this.$ionicLoading = $ionicLoading;
        this.campaignId = $stateParams.campaignId;
        this.contactNotesLocked = true;
        this.campaignCurrencySymbol = '';
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.MessageBox = MessageBox;
        this.ApiTasks = ApiTasks;

        this.filterParams = {
            isCustomerContact: undefined,
            firstQueryResult: undefined,
        };

        this.cleaveNumeral = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
        };
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>',
            duration: 10000,
        });

        this.getCurrencies();
        this.getCampaign();
        this.getCampaignContact();
        this.createRedirectPathInTaskService();
    }

    getCampaignContact() {
        this.ApiCampaigns.getCampaignContact(
            this.campaignId,
            this.contactId
        ).then((res) => {
            if (typeof res != 'undefined') {
                let isCustomerContact = !!res.contactInfo.contact.customer;
                this.contact = res;
                this.getContactExtenstionIds(
                    res.contactInfo.contact.id,
                    isCustomerContact
                );

                if (this.contact.dateTeaserSent) {
                    this.contact.dateTeaserSent = new Date(
                        this.contact.dateTeaserSent
                    ); // avoid date issue
                } else {
                    this.contact.dateTeaserSent = this.DATE_FORMAT;
                }

                if (this.contact.memberStatusUpdated) {
                    this.contact.memberStatusUpdated = new Date(
                        this.contact.memberStatusUpdated
                    ); // avoid date issue
                } else {
                    this.contact.memberStatusUpdated = this.DATE_FORMAT;
                }

                this.contact.levelOfInterest =
                    this.contact.levelOfInterest + '-lOI';
                this.$ionicLoading.hide();
            } else {
                this.$ionicLoading.hide();
            }
        });
    }

    getContactExtenstionIds(contactId, isCustomerContact) {
        // pre-filter the task data for this contact
        this.ApiContacts.getContactExtensionIds(contactId, {
            isCustomerContact: isCustomerContact,
        }).then((res) => {
            if (res) {
                this.taskParameters = {
                    contactExtensionIds: res,
                    contactId: contactId,
                    isCustomerContact: isCustomerContact,
                };
            } else {
                this.taskParameters = {
                    contactExtensionIds: [contactId],
                    contactId: contactId,
                    isCustomerContact: isCustomerContact,
                };
            }

            if (this.campaignId) {
                this.taskParameters.campaignIds = [this.campaignId];
            }
        });
    }

    onSaveClicked() {
        if (
            !this.checkIflevelOfInterestHasPromisedInvestment() ||
            this.contact.promisedInvestment == ''
        )
            this.changePromisedInvestmentToZero();
        this.campaignContactUpdate();
    }

    campaignContactUpdate() {
        delete this.tempContact;
        this.contact.levelOfInterest = this.contact.levelOfInterest.substring(
            0,
            this.contact.levelOfInterest.length - 4
        );
        if (this.contact.dateTeaserSent === this.DATE_FORMAT) {
            this.contact.dateTeaserSent = null;
        }
        if (this.contact.memberStatusUpdated === this.DATE_FORMAT) {
            this.contact.memberStatusUpdated = null;
        }

        this.ApiCampaigns.updateCampaignContact(
            this.campaignId,
            this.contactId,
            this.contact
        ).then((res) => {
            this.contact = res;

            this.contact.dateTeaserSent = this.setDate(
                this.contact.dateTeaserSent
            );
            this.contact.memberStatusUpdated = this.setDate(
                this.contact.memberStatusUpdated
            );

            this.contact.levelOfInterest =
                this.contact.levelOfInterest + '-lOI';
            this.contactNotesLocked = !this.contactNotesLocked;
        });
    }

    setDate(date) {
        if (date) {
            return new Date(date); // avoid date issue
        }
        return this.DATE_FORMAT;
    }

    getCurrencies() {
        this.ApiPicklist.getCurrencies().then((currencies) => {
            if (currencies) {
                this.currencies = currencies;
            }
        });
    }

    getCampaign() {
        this.ApiCampaigns.getCampaign(this.campaignId).then((campaign) => {
            if (campaign) {
                this.campaign = campaign;
                this.campaignCurrencySymbol = this.getCurrency(
                    campaign.campaignCurrency
                )[0].symbol;
            }
        });
    }

    getCurrency(currencyCode) {
        return this.currencies.data.filter((c) => {
            return c.shortName === currencyCode;
        });
    }

    popUp($event) {
        $event.preventDefault();
        let dialogResult = this.$ionicPopup.confirm({
            title: this.$filter('translate')('REMOVE_CONTACT'),
            template: this.$filter('translate')('REMOVE_CAMPAIGN_CONTACT'),
        });

        dialogResult.then((res) => {
            if (res) {
                this.removeCampaignContact(this.contact);
            }
        });
    }

    removeCampaignContact(contact) {
        var contactIds = { contactIds: [contact.id] };
        this.ApiCampaigns.deleteCampaignContact(
            this.campaignId,
            contactIds
        ).then((res) => {
            if (res) {
                if (
                    res.length > 0 &&
                    !this.checkIfContactExistsInCampaign(contact, res[0])
                ) {
                    this.$state.go(
                        'campaignDetail',
                        { campaignId: this.campaignId },
                        { reload: true }
                    );
                } else {
                    this.MessageBox.showFailMessage(
                        'CAMPAIGN_CONTACT',
                        'REMOVE'
                    );
                }
            } else if (res == null) {
                this.$state.go(
                    'campaignDetail',
                    { campaignId: this.campaignId },
                    { reload: true }
                );
            }
        });
    }

    checkIfContactExistsInCampaign(contact, campaign) {
        if (!contact || !campaign)
            throw new Exception(
                'Invalid contact or campaign supplied to checkIfContactExistsInCampaign()'
            );

        if (campaign.contactInfo && campaign.contactInfo.contact) {
            if (contact.contactInfo && contact.contactInfo.contact) {
                return (
                    campaign.contactInfo.contact.id ==
                    contact.contactInfo.contact.id
                );
            }
        } else {
            return false;
        }
    }

    editContactInfo() {
        this.contactNotesLocked = !this.contactNotesLocked;
        this.tempContact = angular.copy(this.contact);
    }

    cancelEdit() {
        this.contactNotesLocked = !this.contactNotesLocked;
        this.contact = angular.copy(this.tempContact);
        delete this.tempContact;
    }

    checkIflevelOfInterestHasPromisedInvestment() {
        let hideInvestment =
            this.contact.levelOfInterest == '100-lOI' ||
            this.contact.levelOfInterest == '200-lOI' ||
            this.contact.levelOfInterest == '300-lOI' ||
            this.contact.levelOfInterest == '400-lOI' ||
            this.contact.levelOfInterest == '1100-lOI' ||
            this.contact.levelOfInterest == '1200-lOI' ||
            this.contact.levelOfInterest == '500-lOI';
        return !hideInvestment;
    }

    changePromisedInvestmentToZero() {
        this.contact.promisedInvestment = 0;
    }

    createRedirectPathInTaskService() {
        this.ApiTasks.campaignContactDetailRedirectParams = {};
        this.ApiTasks.campaignContactDetailRedirectParams.contactId = this.$stateParams.contactId;
        this.ApiTasks.campaignContactDetailRedirectParams.campaignId = this.$stateParams.campaignId;
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaignContactDetail.controller.js
 **/